import { GetStreamHighlights_stream_ppvHighlights } from 'api/streams/types/GetStreamHighlights';

import { HighlightClip } from 'components/OrderStream/StreamHighlights/types';

const UNTITLED_CLIP = 'Highlight';

export const formatClipDuration = (
  seconds: number | null | undefined
): string | null => {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) {
    return null;
  }

  const whole = Math.floor(seconds);
  const hours = Math.floor(whole / 3600);
  const minutes = Math.floor((whole % 3600) / 60);
  const secs = whole % 60;
  const pad = (value: number) => String(value).padStart(2, '0');

  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(secs)}`
    : `${pad(minutes)}:${pad(secs)}`;
};

export const mapHighlightsToClips = (
  highlights: GetStreamHighlights_stream_ppvHighlights[] | null | undefined
): HighlightClip[] =>
  (highlights || []).reduce<HighlightClip[]>((clips, highlight) => {
    if (!highlight.clipUrl) {
      return clips;
    }

    clips.push({
      id: highlight.id,
      title: highlight.title?.trim() || UNTITLED_CLIP,
      clipUrl: highlight.clipUrl,
      thumbnailUrl: highlight.thumbnailUrl,
    });

    return clips;
  }, []);
